// extracted by mini-css-extract-plugin
export default {"content":"input-checkbox-styles_component_content__AEE8J","unChecked":"input-checkbox-styles_component_unChecked__Ha3iW","checked":"input-checkbox-styles_component_checked__W5juu"};